import { SwColumn, SwInfoTileSpotlight } from '@kaa/ui-flanders/components';
import React, { PropsWithChildren, ReactNode } from 'react';

type RemittancesPaperCardProps = {
  title: string;
  text: ReactNode;
  icon?: string;
};

export const RemittancesCard = ({
  title,
  text,
  icon,
  children,
}: PropsWithChildren<RemittancesPaperCardProps>) => {
  return (
    <SwColumn width="3" widthM="6" widthS="12" className="vl-u-spacer">
      <SwInfoTileSpotlight
        modVCenter
        modBadge
        modMedium
        style={{ height: '100%' }}
        title={title}
        icon={icon}
        footer={children}
      >
        {text}
      </SwInfoTileSpotlight>
    </SwColumn>
  );
};
